// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'swiper/dist/css/swiper.css'
import "@/assets/styles/reset.css"
import api from './api/api.js'
import {addConsult} from '@/utils/consult.js'


const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
if (!flag) {
  require('styles/reset.css');
} else {
  require('styles/reset_mobile.css');
}
var wx = require("weixin-js-sdk");
Vue.config.productionTip = false
Vue.prototype.$http = api
Vue.prototype.$imgUrl = 'https://guanwang.wsandos.com/static/banner/'
Vue.prototype.$addConsult = addConsult

router.afterEach((to, from, next) => {
  // console.log(to,next,'在之前植入s')
  // if (to.name === 'Cases') { // 这个name是下一级页面的路由name
  //   console.log(to,'在之前植入s')
  // //  this. $router.go(-1)
  //   to.meta.isBack = true // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
  // }
  window.scrollTo(0, 0);
})


Vue.prototype.getJssdk = function(url,showContent) {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //是微信浏览器
    var date = new Date().getTime();
    const jsApiList = [
      "onMenuShareAppMessage",
      "onMenuShareTimeline",
      "onMenuShareQQ",
      "onMenuShareWeibo",
    ];
    this.$http.post(
      "https://eartisanapplets.wsandos.com/api/index/getJssdk",
      { url: url },
      (res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: jsApiList, // 必填，需要使用的JS接口列表
        });

        wx.ready(function () {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          // 注册分享朋友圈事件。
          wx.onMenuShareTimeline({
            title: showContent.title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
            imgUrl:showContent.imgUrl, // 分享图标
            success: function () {
              console.log("success!");
            },
            cancel: function () {
              console.log("cancel!");
            },
          });

          // 注册分享朋友事件
          wx.onMenuShareAppMessage({
            title: showContent.title, // 分享标题
            desc: showContent.desc,
            link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
            imgUrl: showContent.imgUrl, // 分享图标
            success: function () {
              console.log("success!");
            },
            cancel: function () {
              console.log("cancel!");
            },
          });
        });
      }
    );
  }
},


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js